<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content shadow-lg border-0">
        <!-- Encabezado -->
        <div class="modal-header">
          <h5 class="modal-title">Detalles del Envío</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <!-- Cuerpo del Modal -->
        <div class="modal-body p-4">

          <!-- Datos Generales -->
          <div class="mb-4">
            <h6 class="fw-bold text-primary">Datos Generales</h6>

            <!-- Vista de tabla en escritorio -->
            <div class="d-none d-md-block table-responsive">
              <table class="table table-bordered table-sm">
                <tbody>
                  <tr>
                    <td><strong>N° de Rastreo:</strong><br>{{ envio.rastreo }}</td>
                    <td><strong>Area Solicitante:</strong><br>{{ envio.area_solicitante }}</td>
                    <td><strong>Solicitante:</strong><br>{{ envio.solicitante }}</td>
                  </tr>
                  <tr>
                    <td><strong>Número de Pedido:</strong><br>{{ envio.pedidos_concatenados }}</td>
                    <td><strong>Guía Remitente:</strong><br>{{ envio.guias_concatenadas }}</td>
                    <td><strong>Número Factura:</strong><br>{{ envio.facturas_concatenadas }}</td>
                  </tr>
                  <tr>
                    <td><strong>Orden de Compra:</strong><br>{{ envio.oc_concatenadas }}</td>
                    <td colspan="2"><strong>Documentos Extras:</strong><br>{{ envio.documentos_extras_concatenadas }}</td>
                  </tr>
                  <tr>
                    <td colspan="3"><strong>Observaciones:</strong><br>{{ envio.observaciones }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Vista tipo card en móvil -->
            <div class="d-block d-md-none">
              <div class="card p-2 mb-2" v-for="(item, idx) in [
                { label: 'N° de Rastreo', value: envio.rastreo },
                { label: 'Area Solicitante', value: envio.area_solicitante },
                { label: 'Solicitante', value: envio.solicitante },
                { label: 'Número de Pedido', value: envio.pedidos_concatenados },
                { label: 'Guía Remitente', value: envio.guias_concatenadas },
                { label: 'Número Factura', value: envio.facturas_concatenadas },
                { label: 'Orden de Compra', value: envio.oc_concatenadas},
                { label: 'Documentos Extras', value: envio.documentos_extras_concatenadas },
                { label: 'Observaciones', value: envio.observaciones }
              ]" :key="idx">
                <strong>{{ item.label }}:</strong> <br> {{ item.value }}
              </div>
            </div>
          </div>

          <!-- Información de Envío -->
          <div class="mb-4">
            <h6 class="fw-bold text-primary">Información de Envío</h6>

            <!-- Vista tabla escritorio -->
            <div class="d-none d-md-block table-responsive">
              <table class="table table-bordered table-sm">
                <tbody>
                  <tr>
                    <td><strong>RUC Remitente:</strong><br>{{ envio.ruc_remitente }}</td>
                    <td><strong>Remitente (Cliente Inicial - Final):</strong><br>{{ envio.empresa_sucursal }}</td>
                    <td><strong>Dirección:</strong><br>{{ direccionRemitente }}</td>
                  </tr>
                  <tr>
                    <td><strong>RUC Destinatario:</strong><br>{{ envio.ruc_destinatario }}</td>
                    <td><strong>Destinatario (Cliente Inicial - Final):</strong><br>{{ envio.empresa_sucursal_destino }}</td>
                    <td><strong>Dirección:</strong><br>{{ direccionDestinatario }}</td>
                  </tr>
                  <tr>
                    <td><strong>Tipo de Unidad:</strong><br>{{ envio.tipo_unidad_detalle }}</td>
                    <td><strong>Fecha de Salida:</strong><br>{{ formatDate(envio.fecha_salida) }}</td>
                    <td><strong>Fecha de Entrega:</strong><br>{{ formatDate(envio.fecha_entrada_maxima) }}</td>
                  </tr>
                  <tr>
                    <td><strong>Horario de Salida:</strong><br>{{ formatHora(envio.horario_salida) }}</td>
                    <td><strong>Horario de Entrega:</strong><br>{{ formatHora(envio.horario_entrega) }}</td>
                    <td><strong>Guía de Transportista:</strong><br>{{ envio.guias_transportistas_concatenadas || '-' }}</td>
                  </tr>
                  <tr>
                    <td><strong>Estado del Envío:</strong><br>{{ envio.estado_envio }}</td>
                    <td><strong>Tipo de Envío:</strong><br>{{ envio.modalidades_envio }} - {{ envio.tipo_envio }}</td>
                    <td><strong>Lead Time Esperado:</strong><br>{{ envio.lead_time_esperado }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Vista cards en móvil -->
            <div class="d-block d-md-none">
              <div class="card p-2 mb-2" v-for="(item, idx) in [
                { label: 'RUC Remitente', value: envio.ruc_remitente },
                { label: 'Remitente (Cliente Inicial - Final)', value: envio.empresa_sucursal },
                { label: 'Dirección Remitente', value: direccionRemitente },
                { label: 'RUC Destinatario', value: envio.ruc_destinatario },
                { label: 'Destinatario (Cliente Inicial - Final)', value: envio.empresa_sucursal_destino },
                { label: 'Dirección Destinatario', value: direccionDestinatario },
                { label: 'Estado del Envío', value: envio.estado_envio },
                { label: 'Tipo de Envío', value: envio.tipo_envio },
                { label: 'Tipo de Unidad', value: envio.tipo_unidad_detalle || envio.tipo_unidad },
                { label: 'Fecha de Salida', value: formatDate(envio.fecha_salida) },
                { label: 'Fecha de Entrega', value: formatDate(envio.fecha_entrada_maxima) },
                { label: 'Horario de Salida', value: formatHora(envio.horario_salida) },
                { label: 'Horario de Entrega', value: formatHora(envio.horario_entrega) },
                { label: 'Guía de Transportista', value: envio.guias_transportistas_concatenadas || '-' },
                { label: 'Lead Time Esperado', value: envio.lead_time_esperado }
              ]" :key="idx">
                <strong>{{ item.label }}:</strong> <br> {{ item.value }}
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalDetalleEnvio',
  props: {
    show: Boolean,
    envio: Object
  },
  emits: ['close'],
  computed: {
    direccionRemitente() {
      return this.armarDireccion(this.envio?.sucursal_remitente, this.envio?.ubicacion_remitente)
    },
    direccionDestinatario() {
      return this.armarDireccion(this.envio?.sucursal_destinatario, this.envio?.ubicacion_destinatario)
    }
  },
  methods: {
    // La direccion completa solo esta disponible si viene el objeto de sucursal.
    // Si no, se cae a la ubicacion (distrito - provincia) que siempre viene.
    armarDireccion(sucursal, ubicacionFallback) {
      const partes = [
        sucursal?.direccion,
        sucursal?.distrito_nombre,
        sucursal?.provincia_nombre
      ].filter(Boolean)

      if (partes.length) return partes.join(' - ')
      return ubicacionFallback || '-'
    },
    // El backend mezcla formatos: horario_salida viene "15:00:00" y
    // horario_entrega viene "3:00 PM". Se normalizan a 12h.
    formatHora(hora) {
      if (!hora) return '-'

      const texto = String(hora).trim()
      if (!/^\d{1,2}:\d{2}(:\d{2})?$/.test(texto)) return texto

      const [h, m] = texto.split(':').map(Number)
      if (isNaN(h) || isNaN(m)) return texto

      const fecha = new Date(1970, 0, 1, h, m)
      return fecha.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit', hour12: true })
    },
    formatDate(fecha) {
      if (!fecha) return ''

      // Evita desfase por zona horaria cuando la fecha viene en formato YYYY-MM-DD.
      if (typeof fecha === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        const [year, month, day] = fecha.split('-').map(Number)
        return new Date(year, month - 1, day).toLocaleDateString('es-ES')
      }

      return new Date(fecha).toLocaleDateString('es-ES')
    }
  }
}
</script>
